export default "__VITE_ASSET__COd3naPZ__"